import React from 'react'
import styled from 'styled-components'

// Components
import { ICompanyMemberPure } from '../common/models/Company'
import { Icon } from './icon'
import Avatar from './Avatar'
import { IconType } from './icon/IconType'
import ExternIcon from './icon/ExternIcon'

// Utils
import { useAppState } from '../context/AppContext'

// Styles
import { shadows } from '../styles/effects'

interface IAvatarIconProps {
  user?: ICompanyMemberPure
  iconType: IconType
  switchOrder?: boolean
  version?: 'feedback'
}

const AvatarIcon: React.FC<IAvatarIconProps> = ({
  user,
  iconType,
  switchOrder,
  version,
}) => {
  const { theme } = useAppState()

  return (
    <AvatarIconContainer switchOrder={switchOrder}>
      {user ? (
        <StyledAvatar user={user} version={version} />
      ) : (
        <ExternIcon
          size={20}
          color={theme.colors.textLight}
          backgroundSize={36}
          backgroundColor="primaryLight"
        />
      )}

      <StyledIcon
        type={iconType}
        color={theme.colors.textLight}
        size={16}
        switchOrder={switchOrder}
        version={version}
      />
    </AvatarIconContainer>
  )
}

const AvatarIconContainer = styled.div<{ switchOrder?: boolean }>`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: ${({ switchOrder }) => (switchOrder ? 'right' : 'left')};
  width: 48px;
  margin-right: 16px;
`

const StyledIcon = styled(Icon)<{ switchOrder?: boolean; version?: string }>`
  background-color: ${({ theme }) => theme.colors.textLightest};
  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: ${({ version }) => (version === 'feedback' ? '28px' : '24px;')};
  height: ${({ version }) => (version === 'feedback' ? '28px' : '24px;')};
  position: absolute;
  z-index: 1;
  padding: 4px;

  ${({ switchOrder }) => (switchOrder ? 'left: 0' : 'right: 0')};

  > svg {
    position: relative;
  }
`
const StyledAvatar = styled(Avatar)<{ version?: string }>`
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  ${({ version, theme }) =>
    !version &&
    `border: 2px solid ${theme.colors.lightest};
  box-shadow: ${shadows.depthTwo};`};
`

export default AvatarIcon
